<template>
  <div>
    <el-form label-width="80px" :model="formData" ref="formData">
      <el-form-item label="礼品名称" prop="name" :rules="[
        { required: true, message: '名称不能为空' },
      ]">
        <el-input type="text" placeholder="请输入内容" v-model="formData.name" maxlength="12" show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item label="礼品描述" prop="gift_describe">
        <el-input type="textarea" placeholder="请输入内容" v-model="formData.gift_describe" maxlength="50" show-word-limit>
        </el-input>
      </el-form-item>
      <el-form-item label="奖品类型">
        <el-radio-group :disabled="isDisabled" v-model="formData.gift_type">
          <el-radio-button v-for="item in giftTypes" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="适用场景">
        <el-radio-group :disabled="isDisabled" v-model="formData.scene">
          <el-radio-button v-for="item in filteredScenes" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="库存类型" v-if="formData.scene && currentStockTypes.length">
        <el-radio-group :disabled="isDisabled" v-model="formData.type">
          <el-radio-button v-for="item in currentStockTypes" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="礼品类型">
        <el-radio-group :disabled="isDisabled" v-model="formData.type">
          <el-radio-button label="1">店铺库存</el-radio-button>
          <el-radio-button label="2">统一库存</el-radio-button>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="礼品主图" prop="pics" :rules="[
        { required: true, message: '主图不能为空' },
      ]">
        <img v-if="formData.pics != ''" :src="formData.pics" class="banner-uploader" @click="addImgPreview('HOST')" />
        <div class="banner-uploader" v-else @click="addImgPreview('HOST')">
          <i class="iconfont icon-camera"></i>
          上传图片
        </div>
      </el-form-item>
      <!-- <el-form-item label="上架状态">
        <el-switch v-model="formData.status" active-value="1" inactive-value="0" active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
      </el-form-item> -->

      <!-- <el-form-item label="礼品描述">
        <vue-html5-editor :content="formData.intro" ref="editor" :height="360"></vue-html5-editor>
        <span class="tpl_item img" @click="addImgPreview('HTML')" style="">
          <i class="iconfont icon-image"></i>图片
        </span>
      </el-form-item> -->

      <el-form-item>
        <el-button type="primary" @click="onSave('formData')">保存</el-button>
      </el-form-item>
    </el-form>

    <imgPicker :dialog-visible="imgsVisible" :sc-status="isGetImage" @chooseImg="pickImg"
      @closeImgDialog="closeimgsVisible"></imgPicker>

  </div>
</template>
<script>
import imgPicker from "@/components/imageselect";

export default {
  components: {
    imgPicker
  },
  props: {
    info: {
      type: Object,
      default: {}
    },
    giftTypes: {
      type: Array,
      default: []
    },
    scenesList: {
      type: Array,
      default: []
    }
  },
  watch: {
    info: {
      deep: true,
      handler(value) {
        if (value) {
          this.setData(value)
        }
      }
    },
    // 当奖品类型切换时，更新适用场景和库存类型
    'formData.gift_type'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        // 根据新的奖品类型过滤场景，并选择第一个可用场景
        if (this.filteredScenes.length) {
          this.formData.scene = this.filteredScenes[0].value
          // 同时更新库存类型为新场景的第一个库存类型
          this.formData.type = this.currentStockTypes.length ? this.currentStockTypes[0].value : ''
        }
      }
    },
    // 当适用场景切换时，重置库存类型
    'formData.scene'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        // 场景切换后，默认选中新场景的第一个库存类型
        this.formData.type = this.currentStockTypes.length ? this.currentStockTypes[0].value : ''
      }
    }
  },
  data() {
    return {
      formData: {
        name: '',
        gift_describe: '',
        type: '1',
        pics: '',
        status: '1',
        intro: '',
        gift_type: '',
        scene: '',
      },
      imgTypes: '',
      imgsVisible: false,
      isGetImage: false,
      isDisabled: false
    }
  },
  computed: {
    // 根据奖品类型过滤适用场景
    filteredScenes() {
      if (!this.formData.gift_type || !this.scenesList.length) {
        return this.scenesList
      }
      // 如果gift_type是physical，显示所有场景
      if (this.formData.gift_type === 'physical') {
        return this.scenesList
      } else {
        // 其他类型显示third_party场景
        return this.scenesList.filter(item => item.value === 'third_party')
      }
    },
    // 根据选中的场景获取对应的库存类型列表
    currentStockTypes() {
      if (!this.formData.scene || !this.scenesList.length) {
        return []
      }
      var selectedScene = this.scenesList.find(item => item.value === this.formData.scene)
      return (selectedScene && selectedScene.stock_types) ? selectedScene.stock_types : []
    }
  },
  methods: {
    setData(val) {
      if (val.id) {
        this.$refs['formData'].resetFields();
        this.isDisabled = true
        this.formData.name = val.name
        this.formData.gift_describe = val.gift_describe
        this.formData.type = val.type
        this.formData.pics = val.pics
        this.formData.status = val.status
        this.formData.intro = val.intro
        this.formData.gift_type = val.gift_type
        this.formData.scene = val.scene
      } else {
        this.$refs['formData'].resetFields();
        this.formData.status = '1'
        this.isDisabled = false
        this.formData.gift_type = (this.giftTypes[0] && this.giftTypes[0].value) || ''

        // 根据默认的gift_type设置对应的场景
        var defaultGiftType = this.formData.gift_type
        var defaultSceneValue = ''
        if (defaultGiftType === 'physical') {
          // physical类型默认选择wxapp场景
          var wxappScene = this.scenesList.find(item => item.value === 'wxapp')
          defaultSceneValue = wxappScene ? wxappScene.value : ''
        } else {
          // 其他类型默认选择third_party场景
          var thirdPartyScene = this.scenesList.find(item => item.value === 'third_party')
          defaultSceneValue = thirdPartyScene ? thirdPartyScene.value : ''
        }
        this.formData.scene = defaultSceneValue || (this.scenesList[0] && this.scenesList[0].value) || ''

        // 设置默认库存类型为当前场景的第一个库存类型
        var defaultScene = this.scenesList.find(item => item.value === this.formData.scene)
        var defaultStockTypes = defaultScene && defaultScene.stock_types
        this.formData.type = (defaultStockTypes && defaultStockTypes[0] && defaultStockTypes[0].value) || ''
      }
    },
    addImgPreview(i) {
      this.imgTypes = i
      this.imgsVisible = true
      this.isGetImage = true
    },
    pickImg(data) {
      if (this.imgTypes == 'HOST') {
        this.formData.pics = data.url
      } else {
        var loc = this.$refs.editor
        var img = new Image()
        img.src = this.wximageurl + data.url
        if (loc.range) {
          loc.range.insertNode(img)
        } else {
          loc.$refs.content.appendChild(img)
          loc.focus()
          loc.restoreSelection()
        }
        this.formData.intro = loc.$refs.content.innerHTML
      }
      this.imgsVisible = false;
    },
    closeimgsVisible() {
      this.imgsVisible = false;
    },
    onSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = { ...this.formData }
          if (this.info.id) {
            params.id = this.info.id
          }
          this.$emit('onSave', params)
        }
      });
    }
  },
  mounted() {
    this.setData(this.info)
  }
}
</script>
<style scoped lang="scss"></style>
